import { Component } from '@angular/core';
import { Dropdown } from 'primeng/dropdown';

import { SuburbCatalogueService } from '../workspace/catalogue.service';
import { MapToolsService } from '../workspace/map-tools.service';
import { WorkspaceStateService } from '../workspace/workspace-state.service';
import { closeAfterPick } from './suburb-tool-pick';

/**
 * The tool column's editing section (#256, #260): the active region with Grow (and, in Assign mode, the sub-region
 * suburbs join too), or in Sub-region mode the sub-region a click or sweep edits with Add / Remove; then the tool.
 */
@Component({
  selector: 'section[app-suburb-region-tools]',
  templateUrl: './suburb-region-tools.component.html',
  styleUrls: ['./suburb-region-tools.component.scss'],
})
export class SuburbRegionToolsComponent {
  readonly subRegionActions = [
    { label: 'Add', value: 'add' },
    { label: 'Remove', value: 'remove' },
  ];
  readonly tools = [
    { label: 'Pointer', value: 'pointer', key: 'V' },
    { label: 'Lasso', value: 'lasso', key: 'L' },
    { label: 'Polygon', value: 'polygon', key: 'P' },
  ];

  constructor(
    public state: WorkspaceStateService,
    public catalogue: SuburbCatalogueService,
    public mapTools: MapToolsService
  ) {}

  /** Editing is off: still loading, the all-regions review, or a read-only map. */
  get locked(): boolean {
    return this.state.loading || this.state.overview || this.state.readOnly;
  }

  /**
   * A pick in one of these dropdowns. Their handlers can run outside Angular's zone here (measured 2026-10-21:
   * PrimeNG's click, select and its 150 ms delayed hide all ran in the root zone), so a pick left the label, the help
   * text and the open list stale until something else redrew. Close the list now (a keyboard step leaves it open:
   * suburb-tool-pick.ts) and redraw.
   */
  picked(dropdown: Dropdown, change?: { originalEvent?: unknown }): void {
    closeAfterPick(dropdown, change);
    this.state.redraw();
  }
}
